import { useEffect, useState } from 'react';

export interface ScrollEdges {
    atStart: boolean;
    atEnd: boolean;
}

const BOTH_EDGES: ScrollEdges = { atStart: true, atEnd: true };

export function useScrollEdges(
    container: HTMLElement | null,
    ...contentVersions: unknown[]
): ScrollEdges {
    const [edges, setEdges] = useState<ScrollEdges>(BOTH_EDGES);

    useEffect(() => {
        if (!container) {
            setEdges(BOTH_EDGES);
            return;
        }

        const update = () => {
            setEdges({
                atStart: container.scrollLeft <= 0,
                atEnd:
                    container.scrollLeft + container.clientWidth >=
                    container.scrollWidth - 1,
            });
        };

        update();

        container.addEventListener('scroll', update, { passive: true });
        const resizeObserver = new ResizeObserver(update);
        resizeObserver.observe(container);
        for (const child of Array.from(container.children)) {
            resizeObserver.observe(child);
        }

        return () => {
            container.removeEventListener('scroll', update);
            resizeObserver.disconnect();
        };
    }, [container, ...contentVersions]);

    return edges;
}
